import React, { useCallback, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import Common from "../based/Common";
import { NOTIFY, SHIPPING_SERVICES_CODE } from "../based/Constants";
import Radio from "../based/inputs/Radio";
import TFUSelect from "../based/inputs/TFUSelect";
import CommonModal from "../based/Modal";
import { Notify } from "../based/Notify";
import CommonServices from "../based/services/CommonServices";
import OrderServices from "../based/services/OrderServices";
import { FunctionalComponentDetail, FunctionalComponentToPrint } from "./ComponentToPrint";
const ShippingCompany = {
    RANUS: 3,
};
export default function OrderBookingModal(props) {
    const componentRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [msg, setMsg] = useState(null);
    const [shippingCompanyId, setShippingCompanyId] = useState(0);
    const [shippingCompanyCode, setShippingCompanyCode] = useState("");
    const [shippingServices, setShippingServices] = useState([]);
    const [label, setLabel] = useState({});
    const { isShowModal, currentPacking, onClose, order, onSuccess } = props;
    const orderId = currentPacking && currentPacking.operatorOrderTicket ? currentPacking.operatorOrderTicket.orderId : 0;
    const [shippingModel, setShippingModel] = useState({});

    const reactToPrintContent = useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const handlePrint = useReactToPrint({
        content: reactToPrintContent,
        documentTitle: "Shipping Label",
        onBeforeGetContent: () => {},
        onBeforePrint: () => {},
        onAfterPrint: () => onClose(),
        removeAfterPrint: true,
    });

    useEffect(() => {
        _getShippingServices();
    }, [isShowModal]);

    useEffect(() => {
        if (orderId > 0 && shippingCompanyId > 0) getPrintInfo(orderId, shippingCompanyId);
    }, [orderId, shippingCompanyId]);

    useEffect(() => {
        var shipping = shippingServices.find((x) => x.id == shippingCompanyId);
        if (shipping) setShippingCompanyCode(shipping.code);
    }, [shippingCompanyId, shippingServices]);

    const getPrintInfo = async (orderId, shippingCompanyId) => {
        setIsLoading(true);
        let [err, data] = await OrderServices.GetRanusShippingLabel(orderId, shippingCompanyId);
        if (!err && data) {
            setLabel({ ...data });

            //address model
            if (data.order && data.order.shippingCompanyCode == SHIPPING_SERVICES_CODE.VNPOST) {
                let address = data.shippingAddress;
                setShippingModel({
                    provinceCode: address.vnPostProvince,
                    districtCode: address.vnPostDistrict,
                    wardCode: address.vnPostWard,
                });
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
            setLabel({});
        }
    };

    async function _getShippingServices() {
        setIsLoading(true);
        setMsg("Đang tải dữ liệu...");
        let [err, data] = await CommonServices.GetShippingServices();
        if (!err && data) {
            setShippingServices(data);
            var ranus = data.find((x) => x.code == SHIPPING_SERVICES_CODE.RANUS);
            if (ranus) setShippingCompanyId(ranus.id);
        } else {
            setShippingCompanyId(0);
        }
        setMsg("");
        setIsLoading(false);
    }

    async function _handlePrint() {
        if (shippingCompanyId > 0) {
            let currentShipping = shippingServices.find((x) => x.id == shippingCompanyId);
            let shippingCode = "";
            if (currentShipping) shippingCode = currentShipping.code;
            if (orderId > 0) {
                switch (shippingCode) {
                    case SHIPPING_SERVICES_CODE.RANUS:
                        _handlePrintRanus();
                        break;
                    case SHIPPING_SERVICES_CODE.GHN:
                        await _handlePrintGHN();
                        onSuccess(shippingCode);
                        break;
                    case SHIPPING_SERVICES_CODE.VNPOST:
                        if (!shippingModel || !shippingModel.districtCode || !shippingModel.provinceCode || !shippingModel.wardCode || shippingModel.districtCode == -2 || shippingCode.provinceCode == -2 || shippingCode.wardCode == -2) {
                            Notify(NOTIFY.ERROR, "Lỗi", "Xin vui lòng bổ sung đầy đủ thông tin địa chỉ");
                            return;
                        }
                        let order = label.order;
                        let shippingOrderNumber = order.shippingOrderNumber;
                        if (!shippingOrderNumber || shippingCompanyId != order.shippingCompanyId) await _handlePrintVNPOST();
                        handlePrint();
                        break;
                    default:
                        break;
                }
            }
        } else Notify(NOTIFY.WARNING, "Chú ý", "Yêu cầu chọn đơn vị vận chuyển trước khi in nhãn ship");
    }

    async function _handlePrintGHN() {
        let [error, data] = await OrderServices.PrintShippingLabel(orderId, shippingCompanyId, shippingModel);
        if (!error && data) {
            window.open(data.url, "_blank", "noopener,noreferrer");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
        }
    }

    async function _handlePrintVNPOST() {
        let [error, data] = await OrderServices.PrintShippingLabel(orderId, shippingCompanyId, shippingModel);
        if (!error && data) {
            let lb = { ...label };
            let order = lb.order;
            order.shippingOrderNumber = data.url;
            order.sortingCode = data.sortingCode;
            setLabel(lb);
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", error.message ? error.message : "Có lỗi xảy ra trong quá trình in nhãn ship");
        }
    }

    async function _handlePrintRanus() {
        let [error, data] = await OrderServices.PrintShippingLabelRanus(orderId, shippingCompanyId);
        if (!error && data) handlePrint();
    }

    return (
        <CommonModal
            show={isShowModal}
            id={Common.generateGuid()}
            isBusy={isLoading}
            busyMsg={msg}
            title="Chọn đơn vị vận chuyển"
            customButton={
                <button className="btn btn-custom btn-sm m-r-5" onClick={() => _handlePrint()}>
                    <i className="fa fa-print m-r-5" />
                    In nhãn Ship
                </button>
            }
            onClose={() => onClose()}
            size={"lg"}
        >
            <div className={`d-flex flex-column align-items-center justify-content-start`} style={{ height: "75vh", overflowY: "auto" }}>
                <div className="p-20 w-100" style={{ borderBottom: "1px solid black" }}>
                    <h5>Đơn vị phụ trách Vận Chuyển</h5>
                    <div className="">
                        {shippingServices &&
                            shippingServices.length > 0 &&
                            shippingServices.map((item, idx) => {
                                let isHandle = label && label.order && (item.id == label.order.shippingCompanyId ? "(Đang Handle Đơn Hàng)" : "");
                                return (
                                    <Radio
                                        classDiv="mr-3"
                                        key={idx}
                                        id={`${item.id}`}
                                        name="shippingCompanyId"
                                        checked={shippingCompanyId == item.id}
                                        value={item.id}
                                        onCheckedChange={(name, value) => setShippingCompanyId(item.id)}
                                        label={`${item.name} ${isHandle || ""}`}
                                    />
                                );
                            })}
                    </div>
                    <div className="sub-header" style={{ flex: 100 }}>
                        Đối với Ranus tự giao, tem vận chuyển của Ranus tự thiết kế <br />
                        Đối với các đơn vị vận chuyển khác, tem vận chuyển của đơn vị vận chuyển, thông tin bên dưới dùng để tham khảo lại với thông tin tem vận chuyển của ĐVVC
                    </div>
                </div>
                {shippingCompanyId == ShippingCompany.RANUS ? (
                    <React.Fragment>
                        <div className="component-scale">
                            <FunctionalComponentToPrint ref={componentRef} content={label} shippingCompanyId={shippingCompanyId} />
                        </div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {shippingCompanyCode == SHIPPING_SERVICES_CODE.VNPOST && (
                            <div className="w-100" style={{ borderBottom: "1px solid black" }}>
                                <h5>Thông tin quận huyện trên Hệ Thống ĐVVC</h5>
                                <VNPostComponent model={shippingModel} setModel={(model) => setShippingModel(model)} />
                            </div>
                        )}
                        <div className="component-scale">
                            <FunctionalComponentDetail ref={componentRef} content={label} shippingCompanyId={shippingCompanyId} />
                        </div>
                    </React.Fragment>
                )}
            </div>
        </CommonModal>
    );
}

function VNPostComponent({ model, setModel }) {
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);

    useEffect(() => {
        getProvinces();
    }, []);

    useEffect(() => {
        setModel({ ...model, districtCode: -2 });
        getDistricts(model.provinceCode);
        setWards([]);
    }, [model.provinceCode]);

    useEffect(() => {
        setModel({ ...model, wardCode: -2 });
        getWards(model.districtCode);
    }, [model.districtCode]);

    const getProvinces = async () => {
        let [err, data] = await CommonServices.GetListVNPostProvince();
        if (!err && data) setProvinces(data);
        else setProvinces([]);
    };

    const getDistricts = async (provinceCode) => {
        let [err, data] = await CommonServices.GetListVNPostDistrict(provinceCode);
        if (!err && data) setDistricts(data);
        else setDistricts([]);
    };

    const getWards = async (districtCode) => {
        let [err, data] = await CommonServices.GetListVNPostWard(districtCode);
        if (!err && data) setWards(data);
        else setWards([]);
    };

    return (
        <div className="form-group col-md-12">
            <label className="col-form-label required">Thông tin vị trí của đơn vị vận chuyển</label>
            <div className="form-group col-md-12">
                <label className="text_addAddress color_text required">Tỉnh/Thành phố</label>
                <TFUSelect
                    name="province"
                    value={model.provinceCode}
                    options={provinces}
                    required
                    placeholder="--Chọn tỉnh thành--"
                    className="pb-3"
                    onChanged={(value) => {
                        setModel({ ...model, provinceCode: value });
                    }}
                />
            </div>
            <div className="form-group col-md-12">
                <label className="text_addAddress color_text required">Quận/Huyện</label>
                <TFUSelect
                    name="province"
                    value={model.districtCode}
                    options={districts}
                    required
                    placeholder="--Chọn tỉnh thành--"
                    className="address-selection"
                    onChanged={(value) => {
                        setModel({ ...model, districtCode: value });
                    }}
                />
            </div>
            <div className="form-group col-md-12">
                <label className="text_addAddress color_text required">Phường/Xã</label>
                <TFUSelect
                    name="province"
                    value={model.wardCode}
                    options={wards}
                    required
                    placeholder="--Chọn tỉnh thành--"
                    className="address-selection"
                    onChanged={(value) => {
                        setModel({ ...model, wardCode: value });
                    }}
                />
            </div>
        </div>
    );
}
